import { Brikk } from 'components/Brikk';
import { IntlPageTitle } from 'components/intl/IntlPageTitle';
import { Grid } from 'components/layout/Grid';
import React, { useState, useEffect } from 'react';
import { ShouldRender } from 'components/ShouldRender';
import { useUserPermissions } from 'services/user/permissions';
import { LaundryBrikkModalContext } from '../LaundryBrikkModalContext';
import { WhatAndWhenSection } from './components/WhatAndWhenSection';
import { BookingsAndRemindersSection } from './components/BookingsAndRemindersSection/index';
import { BookResourceAndBookingExportSection } from './components/BookResourceAndBookingExportSection';
import { BookingHistoryDetails } from './components/BookingHistoryDetails';
import { DateSelectionSection } from './components/DateSelectionSection';
import { BookingHistoryProvider } from './components/BookingHistory/BookingHistoryContext';

export const LaundryBrikkContent = ({ laundryResources }) => {
  const [selectedResource, setSelectedResource] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [activeTab, setActiveTab] = useState('bookAResource');
  const { checkPermission } = useUserPermissions();
  const isSystemAdmin = checkPermission('system-admin', 'create', 'read', 'update', 'delete', 'assign');
  const isAdmin = checkPermission('admin-users', 'create', 'read', 'update', 'delete', 'assign');

  const showBookingHistoryTab = isSystemAdmin || isAdmin;

  useEffect(() => {
    if (laundryResources?.length > 0 && !selectedResource) {
      setSelectedResource(laundryResources[0]);
    }
  }, [laundryResources]);

  return (
    <LaundryBrikkModalContext.Provider value={{ selectedDate,
      selectedEndDate,
      setSelectedDate, 
      setSelectedEndDate,
      selectedResource,
      setSelectedResource,
      activeTab,
      setActiveTab,
    }}
    >
      <Grid
        brikkLayout
        twoColumns={activeTab === 'bookingHistory'}
      >
        <IntlPageTitle intlTitle="laundryBrikk" />

        <ShouldRender condition={!showBookingHistoryTab}>
          <Grid.Column>
            <Brikk.Heading
              main
              heading="laundryBrikk"
            >
              <DateSelectionSection
                laundryResources={laundryResources}
              />
            </Brikk.Heading>
          </Grid.Column>
        </ShouldRender>

        <BookingHistoryProvider>
          <ShouldRender condition={showBookingHistoryTab}>
            <BookResourceAndBookingExportSection laundryResources={laundryResources} />
          </ShouldRender>

          <ShouldRender condition={activeTab === 'bookingHistory'}>
            <Grid.Column>
              <Brikk.Heading heading="bookingHistory">
                <BookingHistoryDetails />
              </Brikk.Heading>
            </Grid.Column>
          </ShouldRender>
        </BookingHistoryProvider>

        <ShouldRender condition={activeTab === 'bookAResource' || !showBookingHistoryTab}>
          <Grid.Column>
            <Brikk.Heading heading="whatAndWhen">
              <WhatAndWhenSection />
            </Brikk.Heading>
          </Grid.Column>
        </ShouldRender>

        <ShouldRender condition={activeTab === 'bookAResource' || !showBookingHistoryTab}>
          <Grid.Column>
            <Brikk.Heading heading="bookingsAndReminders">
              <BookingsAndRemindersSection
                laundryResources={laundryResources}
              />
            </Brikk.Heading>
          </Grid.Column>
        </ShouldRender>

      </Grid>
    </LaundryBrikkModalContext.Provider>
  );
};
